// extracted by mini-css-extract-plugin
export var animationContainer = "_gz-0";
export var asteriskIcon = "_gz-8";
export var conversationLeftSection = "_gz-4";
export var conversationListItem = "_gz-3";
export var conversationMiddleSection = "_gz-5";
export var conversationRightSection = "_gz-6";
export var detailsContent = "_gz-1";
export var listContainer = "_gz-7";
export var modalContent = "_gz-2";